



















import { Component, Vue } from 'vue-property-decorator';
import Modal from '@/main-components/common/modal/Modal.vue';
import Form, {
  InputData,
  OnSubmitReturn,
} from '@/main-components/common/Form.vue';
import { axios } from '@/utils/axios';

@Component({
  components: {
    Modal,
    Form,
  },
})
export default class ModalGradePaper extends Vue {
  openModal: any = null;
  closeModal: any = null;

  inputs: InputData[] = [
    {
      name: 'name',
      value: '',
      placeholder: 'Nama kertas',
      type: 'text',
      isRequired: true,
      maxLength: 80,
    },
  ];

  mounted() {
    this.$emit('openModalGradePaperAdd', this.openModal);
  }

  openModalAdd(openModal: any) {
    this.openModal = openModal;
  }

  closeModalAdd(closeModal: any) {
    this.closeModal = closeModal;
  }

  async updatePaper(bodyRequest: any): Promise<OnSubmitReturn | null> {
    const response = await this.createGradePaper(bodyRequest.name);

    if (response) {
      return null;
    } else {
      return {
        error: { message: 'Error: cannot create new paper' } as any,
      };
    }
  }

  async createGradePaper(name: string) {
    try {
      const { data } = await axios.post(`/grade-papers/`, {
        name,
      });

      if (data) {
        this.$sendMpEvent({ event: this.$mp_value.AutoGrade_AddPaper });
        this.$router.push(`/auto-grades/${data.uuid}`);
        return data;
      }
    } catch (error) {
      console.log(error);
      return null;
    }
  }
}
